import { render } from "./TheSiteFooter.vue?vue&type=template&id=4267156e&scoped=true"
import script from "./TheSiteFooter.vue?vue&type=script&lang=js"
export * from "./TheSiteFooter.vue?vue&type=script&lang=js"

import "./TheSiteFooter.vue?vue&type=style&index=0&id=4267156e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4267156e"

export default script